import { cn } from "@/lib/utils"
import { Button } from "@/components/ui/button"
import { Link } from "@inertiajs/react"
import { Head } from "@inertiajs/react"

export default function CheckEmail({ className, ...props }) {
  return (
    <>
      <Head>
        <title>founder/mode | Check Your Email</title>
      </Head>
      <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-background p-6 md:p-10">
        <div className="w-full max-w-sm">
          <div className={cn("flex flex-col gap-6 p-6 rounded-lg shadow", className)} {...props}>
            <div className="flex flex-col items-center gap-2">
              <Link
                href="#"
                className="flex flex-col items-center gap-2 font-medium"
              >
                <span className="sr-only">founder/mode</span>
              </Link>
              <h1 className="text-xl font-bold">Check your email</h1>
              <p className="text-center text-sm text-muted-foreground">
                If an account exists with that email, we&apos;ve sent a link to reset your password. The link will expire in 24 hours.
              </p>
            </div>
            <Link href="/login">
              <Button className="w-full">
                Back to Login
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </>
  )
}
